<template>
    <div class="header">
        <header-tag :title="'远程协助记录'"></header-tag>

        <div class="right">
            <plugin-install-tip></plugin-install-tip>
            <a href="#" @click.prevent="refresh" class="default-btn">刷新</a>
        </div>
    </div>
</template>

<script>
// 头部tag内容
import HeaderTag from '_c/tagTitle/headerTag';
import PluginInstallTip from '_sc/pluginInstallTip';

export default {
  name: 'allBarHeader',
  components: {
    HeaderTag,
    PluginInstallTip
  },
  methods: {
    refresh() {
      let l = window.$msg.loading('请稍候...');
      setTimeout(() => {
        l.destroy()();
      }, 300);
      this.$emit('refresh');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";

.header {
    padding-left: 30px;
    // padding-top: 20px;
    text-align: left;
    position: relative;
    z-index: 10;
}
.right {
    float: right;
    padding-right: 20px;
    .default-btn {
        margin-left: 10px;
        line-height: normal;
        text-align: center;
        cursor: pointer;
        img {
            margin-left: 12px;
        }
    }
    .default-btn:hover {
        background-color: #fff;
    }
}
</style>
